import { createAsyncThunk } from "@reduxjs/toolkit";
import coreAPIs from "services/api/core";
import publisherAPIs from "services/api/publisher";

import magnifiAPI from "../../services/api/magnifi";

export const getPreSignedUrl = createAsyncThunk("common/getPreSignedUrl", async (payload) => {
  try {
    const response = await magnifiAPI.getPreSignedUrl(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const updateDownloadStatus = createAsyncThunk("common/updateDownloadStatus", async (payload) => {
  try {
    const response = await magnifiAPI.updateDownloadStatus(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const getOTP = createAsyncThunk("common/getOTP", async (payload) => {
  try {
    const response = await magnifiAPI.getOTP(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const uploadFileToS3 = createAsyncThunk("common/uploadToS3", async (payload) => {
  try {
    const response = await magnifiAPI.uploadToS3(payload);

    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const sendErrorReport = createAsyncThunk("common/sendErrorReport", async (payload) => {
  try {
    const response = await publisherAPIs.sendErrorReport(payload);

    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
});

export const getContentType = createAsyncThunk("common/contentType", async (payload) => {
  try {
    const response = await magnifiAPI.getContentType(payload);

    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const checkValidStream = createAsyncThunk("common/validStream", async (payload) => {
  try {
    const response = await magnifiAPI.checkValidStream(payload);

    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const uploadBumper = createAsyncThunk("common/uploadBumper", async (payload) => {
  try {
    const response = await magnifiAPI.uploadBumper(payload);

    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const getUrlDuration = createAsyncThunk("common/urlDuration", async (payload) => {
  try {
    const response = await magnifiAPI.getUrlDuration(payload);

    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const getWorkspaceConfig = createAsyncThunk("common/workspaceConfig", async (payload) => {
  try {
    const response = await magnifiAPI.getWorkspaceConfig(payload);

    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const syncTv2PlayerData = createAsyncThunk("common/syncTv2PlayerData", async (payload) => {
  try {
    const response = await magnifiAPI.syncTv2PlayerData(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const passThroughDownload = createAsyncThunk("common/passThroughDownload", async (payload) => {
  try {
    if (payload?.payload?.url?.includes("d2slha0cimpjbc.cloudfront.net/content/")) {
      return {
        status: true,
        message: "Download video api success",
        data: {
          url: payload.payload.url,
        },
      };
    }
    const response = await magnifiAPI.passThroughDownload(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const validateMediaContent = createAsyncThunk("common/validateMediaContent", async (payload) => {
  try {
    const response = await coreAPIs.validateMediaContent(payload);

    return response?.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});
